import { Card, PageHeader, Input, Select, Btn, Table } from "../../components/shared/UIComponents";

export function VendorManagement() {
  const vendors = [
    { n: "ABC Electricals", c: "Electrical", p: "9876543210", e: "abc@gmail.com", g: "27ABCDE1234F1Z5" },
    { n: "Fix-It Plumbing", c: "Plumbing", p: "9123456789", e: "fixit@gmail.com", g: "" },
  ];
  return (
    <Card>
      <PageHeader title="Vendor Management" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Input label="Vendor Name" placeholder="Enter Vendor Name" />
          <Select label="Category" options={["Select", "Electrical", "Plumbing", "Housekeeping", "Security", "Lift", "CCTV", "Carpentry", "Gardening"]} />
          <Input label="Phone Number" placeholder="Enter Phone No" />
          <Input label="Email" placeholder="Enter Email" />
          <Input label="GST Number" placeholder="Enter GST No" />
          <Input label="PAN Number" placeholder="Enter PAN No" />
          <div style={{ gridColumn: "span 3" }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Address</label>
            <textarea placeholder="Enter Vendor Address" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 60 }} />
          </div>
          <div style={{ display: "flex", gap: 10 }}><Btn>Save</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        </div>
        <Table columns={["SrNo", "Vendor Name", "Category", "Phone", "Email", "GST No", "Edit", "Delete"]} rows={vendors}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.n}</td>,
            <td style={{ padding: "9px 12px" }}>{r.c}</td>,
            <td style={{ padding: "9px 12px" }}>{r.p}</td>,
            <td style={{ padding: "9px 12px", fontSize: 12 }}>{r.e}</td>,
            <td style={{ padding: "9px 12px", fontFamily: "monospace", fontSize: 12 }}>{r.g}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export function BillGeneration() {
  return (
    <Card>
      <PageHeader title="Bill Generation" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 20 }}>
          <Select label="Financial Year" options={["2025-2026", "2024-2025", "2023-2024"]} />
          <Select label="Bill Month" options={["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"]} />
          <Select label="Bill Type" options={["Regular", "Supplementary"]} />
          <Select label="Wing/Block" options={["All", "A", "B", "C"]} />
          <Input label="Bill Date" type="date" />
          <Input label="Due Date" type="date" />
        </div>
        <div style={{ background: "#f0f7ff", border: "1px solid #bbdefb", borderRadius: 10, padding: 16, marginBottom: 20 }}>
          <div style={{ fontWeight: 600, color: "#1565c0", marginBottom: 10 }}>Bill Preview Summary</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12 }}>
            {[["Total Flats", "1344"], ["Bills to Generate", "1344"], ["Avg Bill Amount", "₹2,115"], ["Total Amount", "₹28,42,860"]].map(([l, v]) => (
              <div key={l} style={{ background: "#fff", borderRadius: 8, padding: 12, textAlign: "center", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#1565c0" }}>{v}</div>
                <div style={{ fontSize: 11, color: "#78909c" }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn>Generate Bills</Btn>
          <Btn bg="#0f9d58">Preview</Btn>
          <Btn bg="#f57c00">Print All</Btn>
          <Btn bg="#607d8b">Email All</Btn>
        </div>
      </div>
    </Card>
  );
}

export function Receipts() {
  const receipts = [
    { no: "RCP001", flat: "F0102", name: "Abhishek Singh", amt: "3250", mode: "Online", date: "2025-10-05" },
    { no: "RCP002", flat: "F0103", name: "Ashok Kumar", amt: "2800", mode: "Cheque", date: "2025-10-08" },
    { no: "RCP003", flat: "F0104", name: "Sohail V Bhagat", amt: "3100", mode: "Cash", date: "2025-10-10" },
  ];
  return (
    <Card>
      <PageHeader title="Receipts" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Select label="Select Flat" options={["Select Flat", "F0102 - Abhishek Singh", "F0103 - Ashok Kumar", "F0104 - Sohail V Bhagat"]} />
          <Input label="Receipt No" defaultValue="RCP004" />
          <Input label="Receipt Date" type="date" />
          <Select label="Payment Mode" options={["Select", "Cash", "Cheque", "Online", "NEFT", "RTGS", "UPI"]} />
          <Input label="Cheque / Ref No" placeholder="Cheque or Reference No" />
          <Input label="Bank Name" placeholder="Enter Bank Name" />
          <Input label="Amount" placeholder="Enter Amount" />
          <Input label="Remarks" placeholder="Enter Remarks" />
          <div style={{ gridColumn: "span 4", display: "flex", gap: 10 }}><Btn>Save Receipt</Btn><Btn bg="#42a5f5">Refresh</Btn><Btn bg="#0f9d58">Print</Btn></div>
        </div>
        <Table columns={["SrNo", "Receipt No", "Flat", "Member Name", "Amount", "Mode", "Date", "Print"]} rows={receipts}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", color: "#1565c0", fontWeight: 600 }}>{r.no}</td>,
            <td style={{ padding: "9px 12px" }}>{r.flat}</td>,
            <td style={{ padding: "9px 12px" }}>{r.name}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 600 }}>₹{r.amt}</td>,
            <td style={{ padding: "9px 12px" }}><span style={{ background: "#e3f2fd", color: "#1565c0", padding: "2px 8px", borderRadius: 5, fontSize: 12 }}>{r.mode}</span></td>,
            <td style={{ padding: "9px 12px", color: "#78909c", fontSize: 12 }}>{r.date}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#e3f2fd", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🖨️</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export function Payments() {
  const payments = [
    { no: "PAY001", vendor: "ABC Electricals", category: "Electrical", amt: "12500", mode: "Cheque", date: "2025-10-01" },
    { no: "PAY002", vendor: "Fix-It Plumbing", category: "Plumbing", amt: "8000", mode: "Online", date: "2025-10-05" },
  ];
  return (
    <Card>
      <PageHeader title="Payments" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Input label="Voucher No" defaultValue="PAY003" />
          <Input label="Payment Date" type="date" />
          <Select label="Payment Mode" options={["Select", "Cash", "Cheque", "Online", "NEFT", "RTGS"]} />
          <Select label="Select Vendor" options={["Select", "ABC Electricals", "Fix-It Plumbing"]} />
          <Select label="Expense Category" options={["Select", "Maintenance", "Repair", "Utility", "Salary", "Other"]} />
          <Input label="Amount" placeholder="Enter Amount" />
          <Input label="Cheque / Ref No" placeholder="Cheque or Reference No" />
          <Input label="Bank Name" placeholder="Bank Name" />
          <Input label="Narration" placeholder="Enter Narration" />
          <div style={{ gridColumn: "span 3", display: "flex", gap: 10 }}><Btn>Save Payment</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        </div>
        <Table columns={["SrNo", "Voucher No", "Vendor", "Category", "Amount", "Mode", "Date", "Print"]} rows={payments}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", color: "#1565c0", fontWeight: 600 }}>{r.no}</td>,
            <td style={{ padding: "9px 12px" }}>{r.vendor}</td>,
            <td style={{ padding: "9px 12px" }}>{r.category}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 600, color: "#d32f2f" }}>₹{r.amt}</td>,
            <td style={{ padding: "9px 12px" }}><span style={{ background: "#fff3e0", color: "#f57c00", padding: "2px 8px", borderRadius: 5, fontSize: 12 }}>{r.mode}</span></td>,
            <td style={{ padding: "9px 12px", color: "#78909c", fontSize: 12 }}>{r.date}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#e3f2fd", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🖨️</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export default VendorManagement;
